module.exports = __webpack_public_path__ + "media/images/img_not_found-8667ba5552e10808db17a5e83a0aec50.png";